import { NetworkType } from "../../apollo/graphql.generated";
export const BlockchainMainnets = [
    NetworkType.ETHEREUM,
    NetworkType.POLYGON,
    NetworkType.ARBITRUM,
    NetworkType.OPTIMISM,
    NetworkType.BASE,
    NetworkType.ZORA,
    NetworkType.FORMA,
    NetworkType.MANTLE,
    NetworkType.SCROLL,
    NetworkType.ZK_SYNC_ERA,
    NetworkType.SHAPE,
    NetworkType.CYBER,
    NetworkType.ZERO,
    NetworkType.APECHAIN,
];
export const UnsupportedMarketplaceChains = [
    // too much data, not enough sales
    NetworkType.POLYGON,
    // reservoir does not support those any more
    NetworkType.MANTLE,
    NetworkType.ZK_SYNC_ERA,
    NetworkType.SCROLL,
    NetworkType.CYBER,
];
export const BlockchainTestnets = [
    NetworkType.SEPOLIA,
    NetworkType.BASE_SEPOLIA,
];
export const SupportedCrossChainMainnets = [
    NetworkType.ETHEREUM,
    NetworkType.ARBITRUM,
    NetworkType.OPTIMISM,
    NetworkType.BASE,
    NetworkType.ZORA,
    NetworkType.SCROLL,
    NetworkType.FORMA,
    NetworkType.ZK_SYNC_ERA,
    NetworkType.SHAPE,
    NetworkType.CYBER,
    NetworkType.ZERO,
    NetworkType.APECHAIN,
    NetworkType.ABSTRACT,
];
export const SupportedCrossChainTestnets = [
    NetworkType.SEPOLIA,
    NetworkType.BASE_SEPOLIA,
];
